import { CSSProperties } from 'react';
import type { FrameAlignment } from '../../content-composer/types';

type EmailTableProps = React.TableHTMLAttributes<HTMLTableElement> & {
  alignment?: FrameAlignment;
  backgroundColor?: string;
  fullWidth?: boolean;
};

export const EmailTable = ({
  alignment = 'center',
  backgroundColor,
  children,
  fullWidth = true,
  style,
  ...props
}: EmailTableProps) => (
  <table
    align={alignment}
    // eslint-disable-next-line react/no-unknown-property
    bgcolor={backgroundColor}
    border={0}
    cellPadding={0}
    cellSpacing={0}
    role='presentation'
    width={style?.width ? style.width : fullWidth ? '100%' : undefined}
    style={{ backgroundColor, width: fullWidth ? '100%' : undefined, textAlign: alignment, ...style }}
    {...props}
  >
    <tbody>{children}</tbody>
  </table>
);

const EmailTableRow = (props: React.HTMLAttributes<HTMLTableRowElement>) => <tr {...props} />;

type EmailTableSectionProps = React.TdHTMLAttributes<HTMLTableCellElement> & {
  alignment?: FrameAlignment;
  padding?: CSSProperties;
};

const EmailTableCell = ({ alignment = 'center', padding, style, ...props }: EmailTableSectionProps) => (
  <td {...props} align={alignment} style={{ ...style, ...padding, textAlign: alignment }} />
);

EmailTable.Row = EmailTableRow;
EmailTable.Cell = EmailTableCell;
